"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayer = void 0;
const registry_call_1 = require("./registry-call");
const contentTypes = require("./content-types");
/**
 * Pulls a blob with layer content type.
 *
 * OCI Distribution Specification endpoint: `/v2/<name>/blobs/<digest>`
 *
 * ## Caution
 *
 * Blobs are downloaded into RAM
 *
 *  - large blobs can cause RAM exhaustion
 *  - large blobs can exceed Node.js `buffer.constants.MAX_LENGTH`
 *    - 32-bit architecture: 2^30 - 1 (about 1 GiB)
 *    - 64-bit architecture:
 *       - Node.js < 22: 2^30 - 1 (about 1 GiB)
 *       - Node.js >= 22: 2^53 - 1 (about 8 PiB)
 *
 * ## Alternatives
 *
 * - `downloadLayer`: pulls a blob to file using streaming
 *
 * @returns Returns HTTP response body.
 */
async function getLayer(registryBase, repo, digest, username, password, options = {}, callChainObserver = { visitedUrls: [] }) {
    var _a;
    const accept = `${(_a = options.acceptLayer) !== null && _a !== void 0 ? _a : contentTypes.LAYER}`;
    const endpoint = `/${repo}/blobs/${digest}`;
    options = Object.assign({ json: false, encoding: null }, options);
    const layerResponse = await (0, registry_call_1.registryV2Call)(registryBase, endpoint, accept, callChainObserver, username, password, options);
    // When the content type is wrongly set to text instead of binary, response body is returned as string instead of a buffer
    // This forces a buffer response.
    if (!(layerResponse.body instanceof Buffer)) {
        return Buffer.from(layerResponse.raw);
    }
    return layerResponse.body;
}
exports.getLayer = getLayer;
//# sourceMappingURL=get-layer.js.map